// extracted by mini-css-extract-plugin
module.exports = {"root":"_3Ljaw","header":"_32JTh","list":"_7Hnlj","item":"Q220F","itemDescription":"_2VHok"};